// extracted by mini-css-extract-plugin
export default {"root":"TopicTypeAddModal_root__QZX7I","required":"TopicTypeAddModal_required__eIZFU","label":"TopicTypeAddModal_label__cjZkS"};